import { useState } from 'react';
import { Button, Card, Form, Input } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import AdminLayout from '@/components/layout/AdminLayout';
import { changePassword } from '@/api/system';
import { clearAuthSession } from '@/utils/auth';
import { toast } from '@/utils/toast';

interface PasswordFormValues {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export default function ChangePasswordPage() {
  const [form] = Form.useForm<PasswordFormValues>();
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (values: PasswordFormValues) => {
    setSaving(true);
    try {
      await changePassword({ oldPassword: values.oldPassword, newPassword: values.newPassword });
      toast.success('密码修改成功，请重新登录');
      clearAuthSession();
      window.setTimeout(() => window.REACT_APP_NAVIGATE?.('/login'), 500);
    } catch (error: any) {
      toast.error(error.message || '密码修改失败');
    } finally {
      setSaving(false);
    }
  };

  return (
    <AdminLayout pageTitle="修改密码" activeKey="">
      <Card className="max-w-2xl" title="修改登录密码">
        <div className="mb-6 text-sm text-gray-500">
          修改成功后当前账号将退出登录，请使用新密码重新登录。
        </div>
        <Form form={form} layout="vertical" onFinish={handleSubmit} requiredMark={false} className="max-w-md">
          <Form.Item label="当前密码" name="oldPassword" rules={[{ required: true, message: '请输入当前密码' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="请输入当前密码" autoComplete="current-password" />
          </Form.Item>
          <Form.Item
            label="新密码"
            name="newPassword"
            rules={[
              { required: true, message: '请输入新密码' },
              { min: 6, max: 32, message: '密码长度必须为6-32位' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || value !== getFieldValue('oldPassword')) return Promise.resolve();
                  return Promise.reject(new Error('新密码不能与当前密码相同'));
                },
              }),
            ]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="请输入6-32位新密码" autoComplete="new-password" />
          </Form.Item>
          <Form.Item
            label="确认新密码"
            name="confirmPassword"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: '请再次输入新密码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || value === getFieldValue('newPassword')) return Promise.resolve();
                  return Promise.reject(new Error('两次输入的新密码不一致'));
                },
              }),
            ]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="请再次输入新密码" autoComplete="new-password" />
          </Form.Item>
          <Form.Item className="mb-0 pt-2">
            <Button type="primary" htmlType="submit" loading={saving}>确认修改</Button>
          </Form.Item>
        </Form>
      </Card>
    </AdminLayout>
  );
}
